import * as types from '../actions/actionTypes';
import initalState from './initialState';

function getRunFromState(state, driverRuns) {
  let {loaded, items} = driverRuns;
  if(!loaded){
    return state;
  }
  let found = items.filter(x => x.id == state.id);
  let returnValue = found.length == 1 ? {...found} : state;
  return returnValue;
}

export default function runReducer(state = initalState.run, action){
  switch(action.type) {
    case types.LOAD_RUN_SUCCESS:
      return {...action.run};
    case types.RUN_LOCATION_CHECKIN_SUCCESS:
      return {...action.checkIn.response};
    case types.RUN_LOCATION_TANK_PICKUP_SUCCESS:
      return {...action.update.response};
    case types.RUN_LOCATION_ADDNOTE_SUCCESS:
      return {...action.update.response};
    case types.LOAD_DRIVER_RUNS_SUCCESS:
      return getRunFromState(state, action.driverRuns);
    case types.LOAD_RUNS_SUCCESS:
      return getRunFromState(state, action.runs);
    default:
      return state;
  }
}
